module.exports = __webpack_public_path__ + "img/iosx.d37bfda2.png";